import React, { useState } from 'react'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import Head from '../../layout/head/Head'
import AdminActivities from './AdminActivities'
import AdminUsers from './AdminUsers'
import AdminChangePassword from './AdminChangePassword'

const AdminDashboard = ({ userRoles }) => {
  const [activeTab, setActiveTab] = useState(!userRoles.ADMIN ? '1' : '2')
  const { t } = useTranslation()

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  return (
    <React.Fragment>
      <Head title={t('admin.title')}/>
      <div className="nk-content-body">
        <div className="nk-block-head nk-block-head-sm">
          <div className="nk-block-between">
            <div className="nk-block-head-content">
              <h3 className="nk-block-title page-title">{t('admin.title')}</h3>
            </div>
          </div>
        </div>
        <div className="nk-block">
          <Nav tabs>
            <NavItem>
              <NavLink
                tag="a"
                href="#tab"
                className={classnames({ active: activeTab === '1', disabled: !userRoles.ADMIN })}
                onClick={(ev) => {
                  ev.preventDefault()
                  toggle('1')
                }}
              >
                {t('admin.tabs.activities')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                tag="a"
                href="#tab"
                className={classnames({ active: activeTab === '2', disabled: !userRoles.ADMIN_PERSONNEL_USERS })}
                onClick={(ev) => {
                  ev.preventDefault()
                  toggle('2')
                }}
              >
                {t('admin.tabs.users')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                tag="a"
                href="#tab"
                className={classnames({ active: activeTab === '3', disabled: true })}
                onClick={(ev) => {
                  ev.preventDefault()
                  // toggle('3')
                }}
              >
                {t('admin.tabs.changePassword')}
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab} style={{ marginTop: 0 }}>
            <TabPane tabId="1">
              <div className="p-4 bg-white border border-top-0 rounded-bottom">
                <AdminActivities/>
              </div>
            </TabPane>
            <TabPane tabId="2">
              <div className="p-4 bg-white border border-top-0 rounded-bottom">
                <AdminUsers/>
              </div>
            </TabPane>
            <TabPane tabId="3">
              <div className="p-4 bg-white border border-top-0 rounded-bottom">
                <AdminChangePassword/>
              </div>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AdminDashboard
